import type React from 'react';

import { Button } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core-react/i18n';

import { useChooseVideoButton } from './hooks/useChooseVideoButton';

export const ChooseVideoButton: React.FC<{ isRecording: boolean }> = ({ isRecording }) => {
	const {
		data: { inputFileRef },
		actions: { handleFileUpload, handleUploadButtonClick },
	} = useChooseVideoButton();

	return (
		<label htmlFor="video-input">
			<input
				type="file"
				accept="video/mp4"
				ref={inputFileRef}
				data-testid="video-input"
				data-qa="video-input"
				id="video-input"
				onChange={handleFileUpload}
				disabled={false}
				tabIndex={-1}
				className="absolute h-px w-px overflow-hidden border-0 p-0 [white-space:nowrap] [clip-path:inset(50%)] [clip:rect(0_0_0_0)]"
			/>
			<Button
				data-testid="choose-video"
				data-qa="choose-video"
				variant="secondary"
				type="button"
				tabIndex={0}
				disabled={isRecording}
				onClick={handleUploadButtonClick}
				className="w-full"
			>
				<Translate value="corgi.petition_actions.supporter_voice_video.choose_file.upload_button.label" />
			</Button>
		</label>
	);
};
